// extractAirportCode — pure extraction of an IATA airport code from a flight.
//
// Extracted verbatim from `FlightLookup.js` (module-level `extractAirportCode`)
// as part of the behavior-preserving refactor (issue #240). Handles both
// formatted flight data (`departure`/`arrival`) and raw FlightAware data
// (`origin`/`destination`), uppercases the result, and strips a leading ICAO `K`.
//
// Totality preserved exactly: returns `'N/A'` when no code is found, matching the
// source.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Extracts an IATA airport code from a flight object.
 *
 * @param {Object} flight - The flight data object (formatted or raw).
 * @param {'departure'|'arrival'} type - Which airport to extract.
 * @returns {string} The uppercase IATA code with any leading `K` stripped, or `'N/A'`.
 */
export function extractAirportCode(flight, type) {
  const formatted = type === 'departure' ? flight.departure : flight.arrival;
  const raw = type === 'departure' ? flight.origin : flight.destination;

  const code = formatted?.airport || raw?.code_iata || raw?.code;
  if (!code) return 'N/A';
  // If it's ICAO format (starts with K), strip the K prefix, otherwise use as-is
  return code.toString().toUpperCase().replace(/^K/, '');
}

export default extractAirportCode;
